import { useState } from 'react';
import { useSelector } from 'react-redux';
import { DialogContentText } from '@mui/material';

import { dialogPropsSelector } from 'store/entities/ui/slice';
import { Input } from 'components/simple';
import { Dialog } from 'components/complex';

const styles = {
  inputLabel: ({ typography, breakpoints }) => ({
    ...typography.body2,
    whiteSpace: 'normal',
    [breakpoints.up('md')]: typography.subtitle1,
  }),
};

export const ConfirmationDialogWithInput = () => {
  const {
    id,
    onConfirm,
    title,
    descriptions,
    validConfirmationWord,
    confirmLabel,
    cancelLabel,
    inputLabel,
    inputPlaceholder,
    isLoading,
  } = useSelector(dialogPropsSelector);

  const [confirmationWord, setConfirmationWord] = useState('');
  const isValidConfirmationWord = confirmationWord.toLowerCase() === validConfirmationWord;

  return (
    <Dialog
      isLoading={isLoading}
      id={id}
      title={title}
      onConfirm={onConfirm}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      isDisabledConfirm={!isValidConfirmationWord}
    >
      {descriptions.map((description = '') => (
        <DialogContentText key={description} id={`${id}-description`} variant="body2" color="text.primary" mb={4}>
          {description}
        </DialogContentText>
      ))}

      <Input
        autoFocus
        id={id}
        label={inputLabel}
        value={confirmationWord}
        onChange={setConfirmationWord}
        placeholder={inputPlaceholder}
        customStyles={{ label: styles.inputLabel }}
      />
    </Dialog>
  );
};
